(function () {
  'use strict';
  if (window.SmarketProductHelp) return;
  window.SmarketProductHelp = true;
  // Keep the user's choice separate from layout measurements. Expanded copy
  // has no height limit, including when fonts, images or the viewport change.
  var descriptionControls = new WeakMap();
  function bindDescriptionReadMore() {
    document.querySelectorAll('body.template-product .product__description .smk-description-read-more').forEach(function (component) {
      var content = component.querySelector('.js-expandable-content');
      var button = component.querySelector('.js-expandable-content-btn');
      var copy = content && content.querySelector('.rte');
      var actions = component.querySelector('.smk-description__actions');
      if (!copy || !button || !actions || descriptionControls.has(component)) return;
      var userExpanded = false;
      var frame;
      function update() {
        var limit = parseFloat(getComputedStyle(component).getPropertyValue('--smk-description-preview')) || 320;
        var needsToggle = Math.max(copy.scrollHeight, copy.getBoundingClientRect().height) > limit + 1;
        var expanded = userExpanded || !needsToggle;
        component.dataset.collapsible = String(needsToggle);
        content.dataset.expanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = userExpanded
          ? (button.dataset.viewLess || 'Show less')
          : (button.dataset.viewMore || 'View full description');
        // Preserve keyboard focus if a resize makes the control unnecessary.
        if (!needsToggle && actions.contains(document.activeElement)) content.focus({ preventScroll: true });
        actions.hidden = !needsToggle;
      }
      function scheduleUpdate() {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }
      var observer = window.ResizeObserver ? new ResizeObserver(scheduleUpdate) : null;
      if (observer) observer.observe(copy);
      descriptionControls.set(component, { update: scheduleUpdate, disconnect: function () {
        if (observer) observer.disconnect();
        cancelAnimationFrame(frame);
      } });
      button.dataset.smkBound = 'true';
      button.addEventListener('click', function () {
        userExpanded = !userExpanded;
        update();
        if (!userExpanded && component.getBoundingClientRect().top < 120) {
          component.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      });
      // Keyboard users must be able to see links inside the clipped preview.
      content.addEventListener('focusin', function (event) {
        if (event.target !== content && content.dataset.expanded === 'false') {
          userExpanded = true;
          update();
        }
      });
      content.addEventListener('load', scheduleUpdate, true);
      update();
    });
  }
  function refreshDescriptions() {
    document.querySelectorAll('.smk-description-read-more').forEach(function (component) {
      var control = descriptionControls.get(component);
      if (control) control.update();
    });
  }
  bindDescriptionReadMore();
  window.addEventListener('load', refreshDescriptions, { once: true });
  window.addEventListener('resize', refreshDescriptions, { passive: true });
  if (document.fonts) document.fonts.ready.then(refreshDescriptions);
  document.addEventListener('shopify:section:load', bindDescriptionReadMore);
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.smk-description-read-more').forEach(function (component) {
      var control = descriptionControls.get(component);
      if (control) control.disconnect();
      descriptionControls.delete(component);
    });
  });

  var configNode = document.getElementById('smk-product-help-data');
  if (!configNode) return;
  var product;
  try { product = JSON.parse(configNode.textContent); } catch (_) { return; }
  function selection() {
    var form = document.querySelector('form.js-main-product-form');
    var id = form && form.querySelector('[name="id"]');
    var variant = product.variants.find(function (v) { return String(v.id) === String(id && id.value); }) || product.variants[0];
    return { form: form, variant: variant };
  }
  document.addEventListener('click', function (event) {
    var login = event.target.closest('[data-product-login]');
    if (login) {
      var current = new URL(location.href), chosen = selection().variant;
      if (chosen) current.searchParams.set('variant', chosen.id);
      var target = new URL(login.href);
      target.searchParams.set('return_to', current.pathname + current.search);
      login.href = target.href;
    }
  });

  function text(tag, value) { var el = document.createElement(tag); el.textContent = value; return el; }
  document.querySelectorAll('[data-spec-query]').forEach(function (root) {
    var form = root.querySelector('form'), input = root.querySelector('input');
    var button = root.querySelector('button'), answer = root.querySelector('[role="status"]');
    var serial = 0, controller;
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      var question = input.value.trim();
      if (!question || button.disabled) return;
      var request = ++serial;
      if (controller) controller.abort();
      controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 35000);
      var chosen = selection().variant;
      button.disabled = true;
      answer.hidden = false;
      answer.replaceChildren(text('p', 'Checking this product’s specifications…'));
      try {
        var response = await fetch(root.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
          body: JSON.stringify({ productId: root.dataset.productId, variantId: chosen ? String(chosen.id) : '', question: question })
        });
        if (!response.ok) throw Error('Unavailable');
        var data = await response.json();
        if (request !== serial) return;
        if (chosen && String(selection().variant.id) !== String(chosen.id)) throw Error('Selection changed');
        answer.replaceChildren();
        var found = data.status === 'found' && Array.isArray(data.facts) && data.facts.length;
        answer.appendChild(text('p', found ? 'The product specifications list:' : 'This isn’t confirmed in this product’s specifications. Please email us to check.'));
        if (found) {
          var list = document.createElement('dl');
          data.facts.slice(0, 3).forEach(function (fact) { list.append(text('dt', fact.label), text('dd', fact.value)); });
          answer.appendChild(list);
          var sources = document.createElement('details');
          sources.appendChild(text('summary', 'View source'));
          data.facts.slice(0, 3).forEach(function (fact) { sources.appendChild(text('p', 'Product specifications · ' + fact.path + ': ' + fact.value)); });
          answer.appendChild(sources);
        } else {
          var link = text('a', 'Email us');
          link.href = '/pages/contact'; link.dataset.productEmail = ''; link.dataset.question = question;
          answer.appendChild(link);
        }
      } catch (_) {
        if (request !== serial) return;
        answer.replaceChildren(text('p', 'We couldn’t check this right now. Please try again or email us.'));
        var fallback = text('a', 'Email us');
        fallback.href = '/pages/contact'; fallback.dataset.productEmail = ''; fallback.dataset.question = question;
        answer.appendChild(fallback);
      } finally { clearTimeout(timeout); if (request === serial) button.disabled = false; }
    });
  });
})();
